import type { RootState } from "types";

export const getLatestKnowledgeItems = (state: RootState) => state.domains.latestKnowledge.items;

export const getLatestKnowledgeIsPending = (state: RootState) => state.domains.latestKnowledge.isPending;

export const getLatestKnowledgeOffset = (state: RootState) => state.domains.latestKnowledge.offset;

export const getLatestKnowledgeHasNextPage = (state: RootState) => state.domains.latestKnowledge.hasNextPage;
